import React from 'react';
import Icon from 'components/Icon';
import {
  MeasureAxisIcon,
  TargetFaceIcon,
  CurveIcon,
  TargetCenterIcon,
  TargetVertexIcon,
  PlaneIcon,
  FaceMidPoint,
  TriangleVertex,
  EdgeMidPointIcon,
} from 'icons';

import { TargetIcon } from './measurements.styled';

export const getTargetMeasureIcon = (itemTgt, ptTypeEnum, isTemp = false) => {
  let icon = <Icon name='more' size='medium' viewBox='0 0 40 40' />;
  let label = null;

  const iconSize = 'large';

  if (itemTgt) {
    const ptType = itemTgt.GetPointType();
    switch (ptType) {
      case ptTypeEnum.PointTargetVertexStart:
      case ptTypeEnum.PointTargetVertexEnd:
        icon = <TargetVertexIcon />;
        label = 'vertex';
        break;
      case ptTypeEnum.PointTargetTriangleVertex:
        icon = <TriangleVertex />;
        label = 'triangle vertex';
        break;
      case ptTypeEnum.PointTargetCenter:
        icon = <TargetCenterIcon />;
        label = 'center';
        break;
      case ptTypeEnum.PointTargetAxis:
        icon = <MeasureAxisIcon />;
        label = 'axis';
        break;
      case ptTypeEnum.PointTargetMiddle:
        if (itemTgt.IsFace()) {
          icon = <FaceMidPoint />;
          label = 'face mid point';
        } else if (itemTgt.IsLine()) {
          icon = <EdgeMidPointIcon />;
          label = 'edge mid point';
        } else if (itemTgt.IsPoint()) {
          icon = itemTgt.polyLineHit ? (
            <Icon name='target_segMid' size={iconSize} viewBox='0 0 40 40' />
          ) : (
            <PlaneIcon />
          );
          label = itemTgt.polyLineHit ? 'edge mid point' : 'face mid point';
        }
        break;
      case ptTypeEnum.PointTargetRayCast:
      case ptTypeEnum.PointTargetMeasureStart:
        if (itemTgt.IsFace()) {
          icon = <TargetFaceIcon />;
          label = 'face point';
        } else if (itemTgt.IsLine()) {
          icon = <CurveIcon />;
          label = 'edge point';
        } else if (itemTgt.IsPoint()) {
          icon = itemTgt.polyLineHit ? <CurveIcon /> : <TargetFaceIcon />;
          label = itemTgt.polyLineHit ? 'edge point' : 'face point';
        } else if (itemTgt.IsTriangle()) {
          icon = <TargetFaceIcon />;
          label = 'triangle point';
        }
        break;
      default:
        break;
    }
  }

  return (
    <TargetIcon
      active={label != null}
      data-for='tempMeasureTooltip'
      data-tip={label || '...'}
      isTemp={isTemp}
    >
      {icon}
    </TargetIcon>
  );
};

export const getMeasurementTypeLabel = (msrType, msrEnum) => {
  if (!msrType || !msrEnum) return null;

  switch (msrType) {
    case msrEnum.MeasurementDistance:
      return 'Distance';
    case msrEnum.MeasurementDistanceOffset:
      return 'Planar offset';
    case msrEnum.MeasurementLength:
      return 'Segment length';
    case msrEnum.MeasurementLengthCurvilinear:
      return 'Curve length';
    case msrEnum.MeasurementRadius:
      return 'Radius';
    case msrEnum.MeasurementAngle:
      return 'Angle';
    default:
      break;
  }
  return null;
};

export const getMeasurementBody = (msrEnum, measure) => {
  const {
    matchesProjected,
    hasProjection,
    projectionVisible,
    type,
    value,
    projValue,
    units,
  } = measure;

  const isAngle = type === msrEnum.MeasurementAngle;
  const unitsStr = isAngle ? '°' : units;
  const valueStr = `${value.toFixed(2).replace('.00', '')} ${unitsStr}`;
  let projValueStr = null;
  if (!matchesProjected && hasProjection && projectionVisible) {
    projValueStr = `${projValue.toFixed(2).replace('.00', '')} ${unitsStr}`;
  }

  return { valueStr, projValueStr };
};
